export default "__VITE_ASSET__BNIYaj9s__"